module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/bravesmash.9b3e2ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/bravesmash.jpg
// module id = dQkB
// module chunks = 0